import 'react-phone-number-input/style.css';

import React from 'react';

import { withRouter } from 'react-router-dom';

import Logo from 'components/ui/Logo';
import NotFound from 'components/ui/NotFound';
import withSignLayout from 'components/ui/withSignLayout';
import SubmitButton from 'components/ui/buttons/SubmitButton';
import NotificationHelper from 'helpers/NotificationHelper';
import AuthContext from 'providers/auth';
import PhoneInput from 'react-phone-number-input';
import SignUpApi from 'api/signup';

class InviteSignUpPage extends React.Component {
  static contextType = AuthContext;

  state = {
    loading: true,
    invite: {},
    message: null,
    error: 0,
    phone: null,
  };

  async componentDidMount() {
    const { match } = this.props;
    const { invite_id } = match.params;

    try {
      const invite = await SignUpApi.get(invite_id);
      this.setState({ invite });
    } catch (error) {
      const response = error.response || {};
      this.setState({ error: response.status });
    } finally {
      this.setState({ loading: false });
    }
  }

  async onSubmit(e) {
    e.preventDefault();

    const { history } = this.props;
    const invite = this.state.invite || {};
    const name = document.getElementById('inputName').value;
    const phone = document.getElementById('inputPhone').value || undefined;

    this.setState({ saving: true });

    try {
      await SignUpApi.create({
        user: {
          name,
          phone,
          email: invite.email,
        },
        invite_id: invite.id,
      });

      NotificationHelper.snack('Seu usuário foi cadastrado com sucesso!');
      // this.context.signIn(user);
      history.push(`/?signin_email=${invite.email}`);
    } catch (error) {
      const response = error.response || {};

      if (response.status === 409) {
        NotificationHelper.snack('Já existe um usuário com o email informado.');
      } else {
        NotificationHelper.snack('Ocorreu um erro inesperado. Por favor, tente novamente.');
      }
    } finally {
      this.setState({ saving: false });
    }
  }

  renderMessage() {
    const message = this.state.message || {};

    if (!message.type) {
      return null;
    }

    return (
      <div className="alert alert-danger mt-4" role="alert">
        {message.description}
      </div>
    );
  }

  render() {
    if (this.state.loading) {
      return <div>Carregando</div>;
    }

    const invite = this.state.invite || {};
    const company = invite.company || {};

    if (this.state.error || invite.accepted_at) {
      return <NotFound description={'Convite indisponível!'} />;
    }

    return (
      <div className="container d-flex flex-column justify-content-center h-100 align-items-center">
        <div style={{ width: 400 }}>
          <Logo width={150} />

          <p className="mt-4">
            Olá! Agora falta muito pouco para você poder fazer parte do time <b>{company.name || invite.company_id}</b> na Youfy. É só preencher o
            formulário abaixo com os seus dados e clicar em salvar.
          </p>

          <form className="mt-4" onSubmit={this.onSubmit.bind(this)}>
            <div className="form-group mb-3">
              <label htmlFor="inputName">Como você deseja ser chamado?</label>
              <input
                type="text"
                autoFocus
                disabled={this.state.saving}
                className="form-control"
                id="inputName"
                placeholder="Informe o seu nome"
                required
              />
            </div>

            <div className="form-group mb-3">
              <label htmlFor="inputEmail">Qual seu telefone?</label>
              <input type="hidden" required id="inputPhone" value={this.state.phone} name="phone" />

              <PhoneInput
                placeholder="Informe o seu telefone"
                numberInputProps={{ className: 'form-control' }}
                defaultCountry="BR"
                value={this.state.phone}
                onChange={phone => this.setState({ phone })}
              />
            </div>

            {this.renderMessage()}

            <div className="mt-4">
              <div>
                <SubmitButton loading={this.state.saving} className="btn btn-primary shadow form-control">
                  Salvar
                </SubmitButton>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default withSignLayout(withRouter(InviteSignUpPage));
